/** Espelha `AnnouncementAudienceType` do backend: um só modo por comunicado. */
export enum AnnouncementAudienceType {
  ALL = 'ALL',
  ROLES = 'ROLES',
  USERS = 'USERS',
}

export const ANNOUNCEMENT_AUDIENCE_TYPE_DESCRIPTION: Record<AnnouncementAudienceType, string> = {
  [AnnouncementAudienceType.ALL]: 'Todos os usuários',
  [AnnouncementAudienceType.ROLES]: 'Funções selecionadas',
  [AnnouncementAudienceType.USERS]: 'Usuários escolhidos',
};
